import { AiFillInstagram, AiFillGithub, AiOutlineFacebook, AiFillLinkedin } from "react-icons/ai";


import './foot.css';
export default function Foot() {
    return (

        <div className="footer-basic">
             <footer>
                <div className="social">
                    <a href="https://www.google.com/"><AiFillInstagram className="icons"/></a>
                    <a href="https://www.google.com/"><AiFillGithub className="icons"/></a>
                    <a href="https://www.google.com/"><AiOutlineFacebook className="icons"/></a>
                    <a href="https://www.google.com/"><AiFillLinkedin className="icons"/></a>
                </div>
                    <ul className="list-inline">
                         <li className="list-inline-item"><a href="https://adega-santa-helena.netlify.app/">Home</a></li>
                        <li className="list-inline-item"><a href="https://adega-santa-helena.netlify.app/galery">Galeria</a></li>
                        <li className="list-inline-item"><a href="https://www.google.com/">Cardapio</a></li>
                        <li className="list-inline-item"><a href="https://www.google.com/">Mesas</a></li>
                        <li className="list-inline-item"><a href="https://www.google.com/">Contato </a></li> 
                        
                    </ul>
                    <p className="copyright">Company Lucas Vidotto © 2022</p>
            </footer> 
    </div>


    )
}